/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import { useError } from 'services/ErrorContext';

const SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minutos

const useCheckSessionExpiration = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { setError, setLoading } = useError();

  const logoutRef = useRef(logout);
  const navigateRef = useRef(navigate);
  const setErrorRef = useRef(setError);
  const setLoadingRef = useRef(setLoading);

  useEffect(() => {
    logoutRef.current = logout;
    navigateRef.current = navigate;
    setErrorRef.current = setError;
    setLoadingRef.current = setLoading;
  }, [logout, navigate, setError, setLoading]);

  useEffect(() => {
    const checkSession = () => {
      const lastActivity = sessionStorage.getItem('lastActivity');
      if (lastActivity) {
        const now = Date.now();
        const lastActivityTime = parseInt(lastActivity, 10);

        if (now - lastActivityTime > SESSION_TIMEOUT) {
          // La sesión ha expirado
          logoutRef.current(setErrorRef.current, setLoadingRef.current);
          // navigateRef.current('/');
          navigate('/');
          localStorage.setItem('tokenExpirado', 'expirado');
        }
      }
    };

    checkSession(); // Verifica la sesión al cargar la aplicación

    const intervalId = setInterval(checkSession, 5 * 60 * 1000); // Verifica cada 5 minutos
    return () => clearInterval(intervalId); // Limpia el intervalo cuando el componente se desmonta
  }, []);
};

export default useCheckSessionExpiration;
